export default __webpack_public_path__ + "static/media/DQO_flowchart.e335049d.png";